/**
 * Local Storage and Configuration Utilities
 * Provides helper functions for accessing local storage data and generating request configs
 */

/**
 * Retrieves user data from local storage
 * Returns parsed user information and role data
 * @returns {Object} Object containing user info and role from localStorage
 * @property {Object|null} userInfo - Parsed user information or null if not found
 * @property {Object|null} userRole - Parsed user role data or null if not found
 */
export const customLocalStorage = () => {
  return {
    userInfo: localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null,

    userRole: localStorage.getItem("userRole")
      ? JSON.parse(localStorage.getItem("userRole"))
      : null,
  };
};

/**
 * Generates request configuration object with auth headers
 * Includes content type and bearer token from local storage if available
 * @returns {Object} Configuration object for API requests
 * @property {Object} headers - Request headers including auth token
 */
export const config = () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        customLocalStorage() &&
        customLocalStorage().userInfo &&
        `Bearer ${customLocalStorage().userInfo.token}`,
    },
  };
};
